<template>
  <div class="listSourcesLive">
    <div class="liveHeader d-flex justify-content-between align-items-center">
      <h6 class="liveTitle">Conexões ativas</h6>
      <small class="liveConnection" v-bind:class="{ liveConnected: connected, liveDisconnected: !connected }">
        {{ connected ? "Conectado" : "Desconectado" }}
      </small>
    </div>

    <div class="liveLoading text-secondary" v-if="loading">
      Carregando transmissões...
    </div>

    <div class="liveEmpty text-secondary" v-if="!loading && rows.length == 0">
      Nenhuma transmissão ativa.
    </div>

    <div class="table-responsive" v-if="!loading && rows.length > 0">
      <table class="table table-sm table-striped table-hover table-bordered liveTable">
        <thead>
          <tr>
            <th>Source</th>
            <th>Evento</th>
            <th>Dispositivo / Audio</th>
            <th>Canais</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in rows" :key="item.stateKey || (item.eventoId + '_' + item.sourceKey)">
            <td>
              <strong>{{ item.sourceNome || item.hostname || item.sourceKey || "-" }}</strong>
              <br>
              <small class="rowId">{{ item.kind === "preview" ? "Preview" : "Transmissao" }}</small>
            </td>
            <td>
              <strong>{{ item.eventLabel || shortEventLabel(item.eventoId) }}</strong>
              <br>
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary liveRemoteButton"
                @click="abrirTransmissaoRemotaEvento(item.eventoId)"
                title="Abrir transmissao remota"
              >
                Remoto
              </button>
            </td>
            <td>
              <strong>{{ item.deviceLabel || item.deviceId || "-" }}</strong>
              <br>
              <small class="rowId">{{ item.audioLabel || item.audioId || "Sem audio" }}</small>
            </td>
            <td class="liveChannelsCell">
              <template v-if="normalizedChannels(item.channels).length > 0">
                <div class="liveChannelsWrap">
                  <button
                    v-for="canal in normalizedChannels(item.channels)"
                    :key="item.stateKey + '_canal_' + canal"
                    type="button"
                    class="btn btn-sm btn-outline-dark liveChannelButton"
                    @click="abrirEventoCanal(item.eventoId, canal)"
                  >
                    {{ canal }}
                  </button>
                </div>
              </template>
              <span v-else>-</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { io } from "socket.io-client";

export default {
  name: "ListSourcesLive",
  methods: {
    socketBaseUrl() {
      var apiUrl = process.env.VUE_APP_URL_API || "";

      if (apiUrl.endsWith("/api")) {
        apiUrl = apiUrl.substring(0, apiUrl.length - 4);
      }

      return apiUrl;
    },
    conectarSocket() {
      this.fecharSocket();

      const token = localStorage.getItem("ckd");

      if (!token) {
        this.loading = false;
        return;
      }

      this.socket = io(this.socketBaseUrl(), {
        auth: {
          role: "manager",
          token,
          sourceKey: "live-monitor",
        },
        transports: ["websocket", "polling"],
      });

      this.socket.on("connect", () => {
        this.connected = true;
        this.solicitarEstado();
      });

      this.socket.on("disconnect", () => {
        this.connected = false;
      });

      this.socket.on("connect_error", () => {
        this.connected = false;
        this.loading = false;
      });

      this.socket.on("source:transmit:state", (payload) => {
        this.aplicarEstado(payload || {});
      });

      this.solicitarEstado();
    },
    solicitarEstado() {
      if (!this.socket) {
        return;
      }

      this.socket.emit("source:transmit:state:request", { eventoId: "" });
    },
    aplicarEstado(payload) {
      const states = payload.transmissionStates || {};
      const next = {};

      Object.keys(states).forEach((key) => {
        const item = states[key] || {};

        if (item.active !== true) {
          return;
        }

        next[key] = {
          ...item,
          eventoId: item.eventoId || key,
          stateKey: key,
        };
      });

      this.transmissionStates = next;
      this.loading = false;
    },
    fecharSocket() {
      if (this.socket) {
        this.socket.removeAllListeners();
        this.socket.disconnect();
      }

      this.socket = null;
      this.connected = false;
    },
    formatChannels(channels) {
      if (!channels || channels.length == 0) {
        return "-";
      }

      return channels.map((channel) => {
        return channel.canal !== undefined ? channel.canal : "?";
      }).join(", ");
    },
    normalizedChannels(channels) {
      if (!channels || channels.length == 0) {
        return [];
      }

      return channels
        .map((channel) => {
          const value = channel && channel.canal !== undefined ? parseInt(channel.canal) : NaN;
          return Number.isNaN(value) ? null : value;
        })
        .filter((value) => value !== null);
    },
    abrirEventoCanal(eventoId, canal) {
      if (!eventoId || canal === undefined || canal === null) {
        return;
      }

      window.open(
        "/view/" + eventoId + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true,
      );
    },
    abrirTransmissaoRemotaEvento(eventoId) {
      if (!eventoId) {
        return;
      }

      window.open(
        "/transmit-remote/" + eventoId,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=950,height=750",
        true,
      );
    },
    formatDateTime(value) {
      if (!value) {
        return "-";
      }

      const date = new Date(value);

      if (Number.isNaN(date.getTime())) {
        return "-";
      }

      return date.toLocaleString();
    },
    shortEventLabel(eventoId) {
      if (!eventoId) {
        return "Evento";
      }

      const value = eventoId.toString();
      if (value.length <= 10) {
        return value;
      }

      return value.substring(0, 6) + "..." + value.substring(value.length - 4);
    },
  },
  computed: {
    rows: function () {
      return Object.values(this.transmissionStates).sort((a, b) => {
        const aSource = String(a.sourceNome || a.hostname || a.sourceKey || "").toLowerCase();
        const bSource = String(b.sourceNome || b.hostname || b.sourceKey || "").toLowerCase();

        if (aSource !== bSource) {
          return aSource.localeCompare(bSource);
        }

        const aPreview = a.kind === "preview" ? 0 : 1;
        const bPreview = b.kind === "preview" ? 0 : 1;

        if (aPreview !== bPreview) {
          return aPreview - bPreview;
        }

        const aTime = new Date(a.updatedAt || a.startedAt || 0).getTime();
        const bTime = new Date(b.updatedAt || b.startedAt || 0).getTime();
        return bTime - aTime;
      });
    },
  },
  mounted() {
    this.conectarSocket();
  },
  beforeDestroy() {
    this.fecharSocket();
  },
  data: function () {
    return {
      socket: null,
      connected: false,
      loading: true,
      transmissionStates: {},
    };
  },
};
</script>

<style>
.listSourcesLive {
  margin-top: 10px;
}

.liveHeader {
  margin-bottom: 8px;
}

.liveTitle {
  margin-bottom: 0;
}

.liveConnection {
  font-size: 12px;
}

.liveConnected {
  color: #28a745;
}

.liveDisconnected {
  color: #8a9299;
}

.liveLoading,
.liveEmpty {
  margin-top: 8px;
}

.liveTable {
  margin-bottom: 0;
}

.liveTable th,
.liveTable td {
  vertical-align: middle;
  white-space: nowrap;
}

.rowId {
  color: #6c757d;
  font-size: 11px;
}

.liveChannelButton {
  margin: 2px 4px 2px 0;
  min-width: 30px;
  padding: 0 6px;
}

.liveRemoteButton {
  font-size: 10px;
  line-height: 1;
  margin-top: 3px;
  min-height: 20px;
  padding: 2px 6px;
}

.liveChannelsCell {
  white-space: normal !important;
}

.liveChannelsWrap {
  display: flex;
  flex-wrap: wrap;
}
</style>